import pl from 'i18n/locales/pl.json';
import en from 'i18n/locales/en.json';

export const TAGLINES = {
  pl: pl.tagline.audioRental,
  en: en.tagline.audioRental,
};

export function taglineForLanguage(language) {
  const lang = (language || 'pl').split('-')[0];
  return TAGLINES[lang] ?? TAGLINES.pl;
}
